import { createStore, combineReducers, applyMiddleware } from "redux";

import appProps from './components/reducers/appProps';
import activeLot from './components/reducers/activeLot';
import multiLang from './components/reducers/multiLang';
import loterii from './components/reducers/loterii';
import defaultVal from './components/reducers/defaultVal';
import bilete from './components/reducers/bilete';
import serverTime from './components/reducers/serverTime';
import runde from './components/reducers/runde';
import rundeActive from './components/reducers/rundeActive';
import rundaSelectata from './components/reducers/rundaSelectata';
import biletTab from './components/reducers/biletTab';
import popVizibil from './components/reducers/popVizibil';
import loading from './components/reducers/loading';
import nrFavorite from './components/reducers/nrFavorite';
import topWiner from './components/reducers/topWiner';
import error from './components/reducers/error';
import changeActiveLot from './components/reducers/changeActiveLot'
import deleteTicketPariat from './components/reducers/deleteTicketPariat'
import mobToggle from './components/reducers/mobToggle'
import conSizeChange from './components/reducers/conSizeChange'
import nrStatistici from './components/reducers/nrStatistici'
import liveRounds from './components/reducers/liveRounds'
import istoricPariuri from './components/reducers/istoricPariuri';
import istoricRunde from './components/reducers/istoricRunde';
import liveLot from './components/reducers/liveLot'
import nrFavoriteMiddle from './components/reducers/nrFavoriteMiddle'
import sessionParam from './components/reducers/sessionParam'
import widgetPromotie from './components/reducers/widgetPromotie'
import widgetToggle from './components/reducers/widgetToggle'

import thunk from "redux-thunk";

export default createStore(
        combineReducers({
                appProps: appProps,
                activeLot: activeLot,
                multiLang: multiLang,
                loterii: loterii,
                defaultVal: defaultVal,
                bilete: bilete,
                serverTime: serverTime,
                runde: runde,
                rundeActive: rundeActive,
                rundaSelectata: rundaSelectata,
                biletTab: biletTab,
                popVizibil: popVizibil,
                loading: loading,
                nrFavorite: nrFavorite,
                topWiner: topWiner,
                error: error,
                changeActiveLot: changeActiveLot,
                deleteTicketPariat: deleteTicketPariat,
                mobToggle: mobToggle,
                conSizeChange: conSizeChange,
                nrStatistici: nrStatistici,
                liveRounds: liveRounds,
                istoricPariuri: istoricPariuri,
                istoricRunde: istoricRunde,
                liveLot: liveLot,
                nrFavoriteMiddle: nrFavoriteMiddle,
                sessionParam: sessionParam,
                widgetPromotie: widgetPromotie,
                widgetToggle: widgetToggle

        }), {}, applyMiddleware(thunk)
);